import { SUMMARY_PERIODS } from '../../../../../projects/ProjectsApi/projects.consts';
import {
  LBSelect,
  LBSelectContent,
  LBSelectItem,
  LBSelectTrigger
} from '@linearb/buzz';

const trendPeriodOptions = [
  { value: SUMMARY_PERIODS.last_30_days, name: 'Last 30 days' },
  { value: SUMMARY_PERIODS.last_3_months, name: 'Last 3 months' },
  { value: SUMMARY_PERIODS.last_6_months, name: 'Last 6 months' },
  { value: SUMMARY_PERIODS.quarter_to_date, name: 'Quarter to date' },
  { value: SUMMARY_PERIODS.year_to_date, name: 'Year to date' }
];

const TrendDurationPicker = ({ value, onChange, disabled }) => {
  const selectedOption = trendPeriodOptions.find(
    option => option.value === value
  );

  return (
    <div>
      <LBSelect onValueChange={onChange} value={value} disabled={disabled}>
        <LBSelectTrigger className='w-auto'>
          <div className='mr-2'>{selectedOption.name}</div>
        </LBSelectTrigger>
        <LBSelectContent>
          {trendPeriodOptions.map(option => (
            <LBSelectItem key={option.value} value={option.value}>
              {option.name}
            </LBSelectItem>
          ))}
        </LBSelectContent>
      </LBSelect>
    </div>
  );
};

export default TrendDurationPicker;
